import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import './FundProfile.css';
import Slider from 'react-slick';
// import marketup from '../../Images/arrow-up.png';
// import marketdown from '../../../Images/Images/arrow-down.png';
import { useNavigate } from "react-router-dom";
import Pagination from '../../CommonUI/Pagination/Pagination';
import { format, parseISO } from 'date-fns';
import MarketMF from "../MarketMF";
import { Vortex } from 'react-loader-spinner'



function FundProfile() {
    const { BaseURL } = useContext(URLstateContext);
    const [DataHolding, setDataHolding] = useState([]);
    const [DataMfHoldingdrop, setDataMfHoldingdrop] = useState([]);
    const [DataMfHoldingdropcat, setDataMfHoldingdropcat] = useState([]);
    const [Category, setCategory] = useState('5946');
    const [Sheme, setSheme] = useState('-');
    const [ShemeCode, setShemeCode] = useState('26');
    const [currentPage, setCurrentPage] = useState(1);
    const [loadingshow, setloadingshow] = useState(false);
    const [valueschemename, setValueschemename] = useState([]);
    const [DataMfHoldingDividend, setDataMfHoldingDividend] = useState([]);
    const [valueLi, setValueLi] = useState('1Month');
    const [DataMfHoldingdropSheme, setDataMfHoldingdropSheme] = useState([]);

    let getDataHolding, getDataHoldingdrop,
        getDataHoldingdropcat, getDataHoldingdropSheme;
    let PageSize = 8;

    useEffect(() => {
        setloadingshow(true);
        window.scrollTo(0, 0)
        const getUrlMfTopHoldingDrop = BaseURL + "MfHoldingDrop";
        fetch(`${getUrlMfTopHoldingDrop}/-/-`)
            .then((response) => response.json())
            .then((dataMHoldingdrop) => {
                getDataHoldingdrop = dataMHoldingdrop.data;
                setDataMfHoldingdrop(getDataHoldingdrop);
                var schemename = getDataHoldingdrop[0].co_name;
                setValueschemename(schemename);
                setloadingshow(false);
                //console.log(getDataHoldingdrop, "MfHoldingDrop")
            })
            .catch((error) => {
            });

        fetch(`${getUrlMfTopHoldingDrop}/${Category}/-`)
            .then((response) => response.json())
            .then((dataMHoldingdropcat) => {
                getDataHoldingdropcat = dataMHoldingdropcat.data;
                setDataMfHoldingdropcat(getDataHoldingdropcat);
                setloadingshow(false);
                //console.log(getDataHoldingdropcat, "MfHoldingDropcat")
            })
            .catch((error) => {
            });

        fetch(`${getUrlMfTopHoldingDrop}/${Category}/${Sheme}`)
            .then((response) => response.json())
            .then((dataMHoldingdropSheme) => {
                getDataHoldingdropSheme = dataMHoldingdropSheme.data;
                setDataMfHoldingdropSheme(getDataHoldingdropSheme);
                setloadingshow(false);
                //console.log(getDataHoldingdropSheme, "MfHoldingDropSheme")
            })
            .catch((error) => {
            });

        const getUrlMfTopHolding = BaseURL + "FundProfile";
        fetch(`${getUrlMfTopHolding}/-/${Category}/-`)
            .then((response) => response.json())
            .then((dataMHolding) => {
                getDataHolding = dataMHolding.data;
                setDataHolding(getDataHolding);
                setloadingshow(false);
                //console.log(getDataHolding, "MfTopHolding")
            })
            .catch((error) => {
            });
    }, [Category, Sheme, ShemeCode, valueLi]);


    const currentTableData = useMemo(() => {
        if (DataHolding != null && DataHolding != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (DataHolding != null && DataHolding != []) {
                if (DataHolding.length > 0) {
                    return DataHolding.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, DataHolding]);

    const routeChange = (paramname) => {
        window.open("/Mutual-Fund/" + paramname.replace(/ /g, '_').replace('&', 'and').replace('+', ''), "_blank");
    }

    return (
        <>
            <div class="col-12 p-0 breadcrumMF ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/mutual-funds">Mutual Fund</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Fund Profile</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='FundPro-loser-sc'>

                            <div className='FundPro-header'>

                                <h2><span>Fund Profile</span></h2>

                            </div>
                            <MarketMF optionValue="Fund Profile" />
                            <div className='FundPro-right'>
                                <div className='FundPro-inner-select'>

                                    {/* aria-label="Select Fund House" */}
                                    <select aria-label="Select Fund House" onChange={(event) => setCategory(event.target.value)}>
                                        <option>Select Fund House</option>
                                        {DataMfHoldingdrop && DataMfHoldingdrop.map(
                                            ({ mf_cocode, co_name }) => (
                                                <option value={mf_cocode} selected={valueschemename === co_name}>{co_name}</option>
                                            )
                                        )}
                                    </select>

                                </div>
                                <div className='TTFundPro-inner-select'>

                                {/* aria-label="Select Month" */}
                                    <select aria-label="Select Month" onChange={(event) => setValueLi(event.target.value)}>
                                        <option value="1Month">1Month</option>
                                        <option value="3month">3Months</option>
                                        <option value="6month">6Months</option>
                                        <option value="1year">1Year</option>
                                        <option value="3year">3Years</option>
                                        <option value="5year">5Years</option>
                                    </select>
                                </div>

                            </div>

                            <div className='FundPro-table table-responsive'>
                                <table className='table'>

                                    {(() => {
                                        if (valueLi === "1Month") {
                                            document.getElementsByClassName('')
                                            return (
                                                <>
                                                    <thead className="hide1">
                                                        <tr>
                                                            <th className='text-left'>Scheme Name</th>
                                                            <th className='text-right'>NAV(&#8377;) on {(currentTableData != null) ? format(parseISO(currentTableData[0].NavDate), 'dd-MMM-yyyy') : ''}</th>
                                                            <th className='text-right'>Inception Date   </th>
                                                            <th className='text-right'>1 Week[%]</th>
                                                            <th className='text-right'>1 Month [%]</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody className="hide1">
                                                        {currentTableData && currentTableData.map(({ Sch_Name, NAVRS, INCFROM, week1, month1 }) => (

                                                            <tr>
                                                                <td className='text-left'><h6 onClick={() => routeChange(Sch_Name)} tabIndex={0} >{Sch_Name}</h6></td>

                                                                <td className='text-right'>{NAVRS.toFixed(2)}</td>
                                                                <td className="text-right">{format(parseISO(INCFROM), 'dd-MMM-yyyy')}</td>
                                                                <td><div className={(week1 != null && week1.toFixed(2)) > 0 ? "textGreen text-right" : "textRed text-right"}> {week1 != null ? week1.toFixed(2) : 0} </div></td>
                                                                <td><div className={(month1 != null && month1.toFixed(2)) > 0 ? "textGreen text-right" : "textRed text-right"}> {month1 != null ? month1.toFixed(2) : 0} </div></td>
                                                            </tr>

                                                        ))}
                                                    </tbody>
                                                </>
                                            )
                                        }
                                        else if (valueLi === "3month") {
                                            return (
                                                <>
                                                    <thead>
                                                        <tr>
                                                            <th className='text-left'>Scheme Name</th>
                                                            <th className='text-right'>NAV(&#8377;) on {(currentTableData != null) ? format(parseISO(currentTableData[0].NavDate), 'dd-MMM-yyyy') : ''}</th>
                                                            <th className='text-right'>Inception Date  </th>
                                                            <th className='text-right'>1 Week[%]</th>
                                                            <th className='text-right'>3 Month [%]</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {currentTableData && currentTableData.map(({ Sch_Name, NAVRS, INCFROM, week1, month3 }) => (

                                                            <tr>
                                                                <td className='text-left'><h6 onClick={() => routeChange(Sch_Name)}>{Sch_Name}</h6></td>

                                                                <td className='text-right'>{NAVRS.toFixed(2)}</td>
                                                                <td className="text-right">{format(parseISO(INCFROM), 'dd-MMM-yyyy')}</td>
                                                                <td><div className={(week1 != null && week1.toFixed(2)) > 0 ? "textGreen text-right" : "textRed text-right"}> {week1 != null ? week1.toFixed(2) : 0} </div></td>
                                                                <td><div className={(month3 != null && month3.toFixed(2)) > 0 ? "textGreen text-right" : "textRed text-right"}> {month3 != null ? month3.toFixed(2) : 0} </div></td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </>
                                            )
                                        }
                                        else if (valueLi === "6month") {
                                            return (
                                                <>
                                                    <thead>
                                                        <tr>
                                                            <th className='text-left'>Scheme Name</th>
                                                            <th className='text-right'>NAV(&#8377;) on {(currentTableData != null) ? format(parseISO(currentTableData[0].NavDate), 'dd-MMM-yyyy') : ''}</th>
                                                            <th className='text-right'>Inception Date  </th>
                                                            <th className='text-right'>1 Week[%]</th>
                                                            <th className='text-right'>6 Month [%]</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        {currentTableData && currentTableData.map(({ Sch_Name, NAVRS, INCFROM, week1, month6 }) => (
                                                            <tr>
                                                                <td className='text-left'><h6 onClick={() => routeChange(Sch_Name)}>{Sch_Name}</h6></td>

                                                                <td className='text-right'>{NAVRS.toFixed(2)}</td>
                                                                <td className="text-right">{format(parseISO(INCFROM), 'dd-MMM-yyyy')}</td>
                                                                <td><div className={(week1 != null && week1.toFixed(2)) > 0 ? "textGreen text-right" : "textRed text-right"}> {week1 != null ? week1.toFixed(2) : 0} </div></td>
                                                                <td><div className={(month6 != null && month6.toFixed(2)) > 0 ? "textGreen text-right" : "textRed text-right"}> {month6 != null ? month6.toFixed(2) : 0} </div></td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </>
                                            )
                                        }
                                        else if (valueLi === "1year") {
                                            return (
                                                <>
                                                    <thead>
                                                        <tr>
                                                            <th className='text-left'>Scheme Name</th>
                                                            <th className='text-right'>NAV(&#8377;) on {(currentTableData != null) ? format(parseISO(currentTableData[0].NavDate), 'dd-MMM-yyyy') : ''}</th>
                                                            <th className='text-right'>Inception Date  </th>
                                                            <th className='text-right'>1 Week[%]</th>
                                                            <th className='text-right'>1 Year[%]</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        {currentTableData && currentTableData.map(({ Sch_Name, NAVRS, INCFROM, week1, year1 }) => (
                                                            <tr>
                                                                <td className='text-left'><h6 onClick={() => routeChange(Sch_Name)}>{Sch_Name}</h6></td>

                                                                <td className='text-right'>{NAVRS.toFixed(2)}</td>
                                                                <td className="text-right">{format(parseISO(INCFROM), 'dd-MMM-yyyy')}</td>
                                                                <td><div className={(week1 != null && week1.toFixed(2)) > 0 ? "textGreen text-right" : "textRed text-right"}> {week1 != null ? week1.toFixed(2) : 0} </div></td>
                                                                <td><div className={(year1 != null && year1.toFixed(2)) > 0 ? "textGreen text-right" : "textRed text-right"}> {year1 != null ? year1.toFixed(2) : 0} </div></td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </>
                                            )
                                        }
                                        else if (valueLi === "3year") {
                                            return (
                                                <>
                                                    <thead>
                                                        <tr>
                                                            <th className='text-left'>Scheme Name</th>
                                                            <th className='text-right'>NAV(&#8377;) on {(currentTableData != null) ? format(parseISO(currentTableData[0].NavDate), 'dd-MMM-yyyy') : ''}</th>
                                                            <th className='text-right'>Inception Date  </th>
                                                            <th className='text-right'>1 Week[%]</th>
                                                            <th className='text-right'>3 Year[%]</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        {currentTableData && currentTableData.map(({ Sch_Name, NAVRS, INCFROM, week1, year3 }) => (
                                                            <tr>
                                                                <td className='text-left'><h6 onClick={() => routeChange(Sch_Name)}>{Sch_Name}</h6></td>

                                                                <td className='text-right'>{NAVRS.toFixed(2)}</td>
                                                                <td className="text-right">{format(parseISO(INCFROM), 'dd-MMM-yyyy')}</td>
                                                                <td><div className={(week1 != null && week1.toFixed(2)) > 0 ? "textGreen text-right" : "textRed text-right"}> {week1 != null ? week1.toFixed(2) : 0} </div></td>
                                                                <td><div className={(year3 != null && year3.toFixed(2)) > 0 ? "textGreen text-right" : "textRed text-right"}> {year3 != null ? year3.toFixed(2) : 0} </div></td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </>
                                            )
                                        }
                                        else if (valueLi === "5year") {
                                            return (
                                                <>

                                                    <thead>
                                                        <tr>
                                                            <th className='text-left'>Scheme Name</th>
                                                            <th className='text-right'>NAV(&#8377;) on {(currentTableData != null) ? format(parseISO(currentTableData[0].NavDate), 'dd-MMM-yyyy') : ''}</th>
                                                            <th className='text-right'>Inception Date  </th>
                                                            <th className='text-right'>1 Week[%]</th>
                                                            <th className='text-right'>5 Year[%]</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>

                                                        {currentTableData && currentTableData.map(({ Sch_Name, NAVRS, INCFROM, week1, year5 }) => (
                                                            <tr>
                                                                <td className='text-left'><h6 onClick={() => routeChange(Sch_Name)}>{Sch_Name}</h6></td>

                                                                <td className='text-right'>{NAVRS.toFixed(2)}</td>
                                                                <td className="text-right">{format(parseISO(INCFROM), 'dd-MMM-yyyy')}</td>
                                                                <td><div className={(week1 != null && week1.toFixed(2)) > 0 ? "textGreen text-right" : "textRed text-right"}> {week1 != null ? week1.toFixed(2) : 0} </div></td>
                                                                <td><div className={(year5 != null && year5.toFixed(2)) > 0 ? "textGreen text-right" : "textRed text-right"}> {year5 != null ? year5.toFixed(2) : 0} </div></td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </>
                                            )
                                        }
                                    })()}
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                    <Vortex
                                        visible={true}
                                        height="80"
                                        width="80"
                                        ariaLabel="vortex-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="vortex-wrapper"
                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                    />
                                    <div className="model_popup">Please Wait...</div>
                                </div> : ""
                                }
                            </div>

                            {(DataHolding != null && DataHolding != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(DataHolding.length != null) ? DataHolding.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>

                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default FundProfile